// Chemin: C:\gestion-copro\src\types\quota.types.ts
// Types pour le système de quota SENTINELLE
// Session 79 : Création du système de garde-fous quota

import { Timestamp } from 'firebase/firestore';

// ============================================
// FORMULES D'ABONNEMENT
// ============================================

export type FormuleAbonnement = 'sentinelle' | 'bouclier' | 'forteresse';

export const QUOTAS_PAR_FORMULE: Record<FormuleAbonnement, number> = {
  sentinelle: 100,
  bouclier: 300,
  forteresse: 600,
};

export const PRIX_PAR_FORMULE: Record<FormuleAbonnement, number> = {
  sentinelle: 149,
  bouclier: 249,
  forteresse: 399,
};

export const PACK_SUPPLEMENTAIRE = {
  analyses: 100,
  prixHT: 29,
};

// ============================================
// DONNÉES QUOTA COPROPRIÉTÉ
// ============================================

export interface QuotaSentinelle {
  // Quota
  formule: FormuleAbonnement;
  sentinelleQuota: number;      // Quota total (formule + packs)
  sentinelleUsage: number;      // Consommation actuelle
  sentinelleResetDate: Timestamp | null;  // Prochaine remise à zéro
  
  // Alertes envoyées (pour ne pas spammer)
  sentinelleAlerte80Envoyee: boolean;
  sentinelleAlerte100Envoyee: boolean;
}

// ============================================
// STATISTIQUES POUR AFFICHAGE
// ============================================

export interface QuotaStats {
  quota: number;
  usage: number;
  restant: number;
  pourcentage: number;          // 0-100
  formule: FormuleAbonnement;
  resetDate: Date | null;
  
  // États d'alerte
  isAlerte80: boolean;          // >= 80%
  isAlerte100: boolean;         // >= 100%
  isBloque: boolean;            // >= 100% (synonyme)
}

// ============================================
// TYPES D'ANALYSE (pour logging)
// ============================================

export type TypeAnalyseSentinelle = 
  | 'document'          // Analyse GED
  | 'email'             // Analyse email entrant
  | 'comptabilite'      // Vérification comptable
  | 'courrier_scud'     // Génération courrier
  | 'assistant'         // Chat conversationnel
  | 'gardien';          // Analyse gardien (reformulation)

export interface LogAnalyseSentinelle {
  coproprieteId: string;
  type: TypeAnalyseSentinelle;
  timestamp: Timestamp;
  tokensUtilises?: number;
  coutEstime?: number;          // En euros
  userId: string;
  details?: string;
}
